import styled from 'styled-components';

export const FilterContainer = styled.div`
width: 100%;
padding: 1.25rem 0 0.25rem 0;
`;
